import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TH2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TH2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 14H22V19H2V14Z"
        fill="#F50101"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4H22V7.75H2V4Z"
        fill="#F50101"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 9H22V14H2V9Z"
        fill="#3D58DB"
      />
      <line x1="2" y1="8" x2="22" y2="8" stroke="white" strokeWidth="2" />
      <line x1="2" y1="15" x2="22" y2="15" stroke="white" strokeWidth="2" />
    </svg>
  );
};

export default TH2424Icon;
